import {
  getResolvedShots,
  getShotsOnTargetPercentage,
  SHOTS_METRIC_KEY,
  SHOTS_ON_TARGET_PERCENT_METRIC_KEY,
} from "./shotsMetrics";

export const getStatsArray = (obj1: any, obj2: any) => {
  const homeStats: Record<string, unknown> =
    obj1 && typeof obj1 === "object" ? { ...obj1 } : {};
  const awayStats: Record<string, unknown> =
    obj2 && typeof obj2 === "object" ? { ...obj2 } : {};

  homeStats[SHOTS_METRIC_KEY] = getResolvedShots(homeStats);
  awayStats[SHOTS_METRIC_KEY] = getResolvedShots(awayStats);
  homeStats[SHOTS_ON_TARGET_PERCENT_METRIC_KEY] =
    getShotsOnTargetPercentage(homeStats);
  awayStats[SHOTS_ON_TARGET_PERCENT_METRIC_KEY] =
    getShotsOnTargetPercentage(awayStats);

  const array = [];
  for (const key in homeStats) {
    array.push({
      key,
      home: homeStats[key],
      away: awayStats[key],
      isShow: true,
    });
  }
  return array;
};
